import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

/** Only lets authenticated users into the app; loads the signed-in user once. */
export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);

  const authenticated = await auth.checkstatus(true);
  if (!authenticated) {
    return router.parseUrl('/login');
  }

  await auth.getUser(true);
  return true;
};
